// extracted by mini-css-extract-plugin
module.exports = {"imageRecipe":"ImageRecipe_imageRecipe__3x2v7"};